import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Toaster } from 'react-hot-toast';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from './contexts/AuthContext';
import { LabourerProvider } from './contexts/LabourerContext';
import { PartnerProvider } from './contexts/PartnerContext';

import LabourerLayout from './layouts/LabourerLayout';
import AdminLayout from './layouts/AdminLayout';
import DesignAndEngineeringLayout from './layouts/DesignAndEngineeringLayout';
import PartnerAdminLayout from './layouts/PartnerAdminLayout';
import PartnerStaffLayout from './layouts/PartnerStaffLayout';

import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

import Dashboard from './components/Dashboard';
import LabourerOnboarding from './components/LabourerOnboarding';
import LicensesAndDocuments from './components/LicensesAndDocuments';
import Labour from './components/Labour';
import Projects from './components/Projects';
import AdminDashboard from './components/AdminDashboard';
import AdminLeaveRequests from './components/AdminLeaveRequests';
import AdminSupport from './components/AdminSupport';
import UserSupport from './components/UserSupport';
import LabourerProfile from './components/LabourerProfile';
import AdminProfile from './components/AdminProfile';
import LabourerLeaveRequests from './components/LabourerLeaveRequests';
import Allocations from './components/Allocations';
import LabourerClockIn from './components/Labourer/LabourerClockIn';
import LabourerTimeEntries from './pages/LabourerTimeEntries';
import QRScanPage from './pages/QRScanPage';
import AdminLiveSessions from './components/AdminLiveSessions';

import DesignAndEngineeringProjects from './components/DesignAndEngineering/DesignAndEngineeringProjects';
import DesignAndEngineeringOverview from './components/DesignAndEngineering/DesignAndEngineeringOverview';
import DesignAndEngineeringPartners from './components/DesignAndEngineering/DesignAndEngineeringPartners';

import PartnerAdminProjects from './components/PartnerAdmin/PartnerAdminProjects';
import PartnerAdminProfile from './components/PartnerAdmin/PartnerAdminProfile';
import PartnerAdminStaff from './components/PartnerAdmin/PartnerAdminStaff';

import PartnerStaffProjects from './components/PartnerStaff/PartnerStaffProjects';
import PartnerStaffProfile from './components/PartnerStaff/PartnerStaffProfile';

import PrivacyPolicy from './components/PrivacyPolicy';
import AdminTimeEntries from './components/AdminTimeEntries';
import PotentialHires from './components/PotentialHires';

import NotFound from './components/NotFound';

import './index.css';
import 'react-date-picker/dist/DatePicker.css';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:id" element={<ResetPassword />} />
          <Route path="/scan/:token" element={<QRScanPage />} />

          <Route path="/l" element={
            <LabourerProvider>
              <LabourerLayout />
            </LabourerProvider>
          }>
            <Route index element={<Dashboard />} />
            <Route path="onboarding" element={<LabourerOnboarding />} />
            <Route path="support" element={<UserSupport />} />
            <Route path="licenses-and-documents" element={<LicensesAndDocuments />} />
            <Route path="leave-requests" element={<LabourerLeaveRequests />} />
            <Route path="profile" element={<LabourerProfile />} />
            <Route path="clock-in" element={<LabourerClockIn />} />
            <Route path="my-work" element={<LabourerTimeEntries />} />
          </Route>

          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="allocations" element={<Allocations />} />
            <Route path="labour" element={<Labour />} />
            <Route path="projects" element={<Projects />} />
            <Route path="leave-requests" element={<AdminLeaveRequests />} />
            <Route path="time-entries" element={<AdminTimeEntries />} />
            <Route path="potential-hires" element={<PotentialHires />} />
            <Route path="clocked-in" element={<AdminLiveSessions />} />
            <Route path="support" element={<AdminSupport />} />
            <Route path="profile" element={<AdminProfile />} />

            <Route path="/admin/design-and-engineering" element={<DesignAndEngineeringLayout />}>
              <Route index element={<DesignAndEngineeringProjects />} />
              <Route path="overview" element={<DesignAndEngineeringOverview />} />
              <Route path="partners" element={<DesignAndEngineeringPartners />} />
            </Route>
          </Route>

          <Route path="/partner" element={
            <PartnerProvider>
              <PartnerAdminLayout />
            </PartnerProvider>
          }>
            <Route index element={<PartnerAdminProjects />} />
            <Route path="profile" element={<PartnerAdminProfile />} />"
            <Route path="staff" element={<PartnerAdminStaff />} />
          </Route>

          <Route path="/partner-staff" element={
            <PartnerProvider>
              <PartnerStaffLayout />
            </PartnerProvider>
          }>
            <Route index element={<PartnerStaffProjects />} />
            <Route path="profile" element={<PartnerStaffProfile />} />"
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  )
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <>
    <Toaster position='bottom-right' />

    <App />

    <div id="portal"></div>
  </>
);

reportWebVitals();
